module.exports = __webpack_public_path__ + "media/Meta_Experience_hd_Denoised_beauty.3f43f992.mp4";